/**
 * Remembers, for this browser tab, which organization requests run in. Requests read it back through
 * getPieveSessionCompanyId and send it as `x-company-id`. Null clears it.
 */
const setPieveSessionCompanyId = (companyId) => {
  try {
    if (companyId) {
      window.sessionStorage.setItem('sessionCompanyId', String(companyId));
    } else {
      window.sessionStorage.removeItem('sessionCompanyId');
    }
  } catch {
    // Storage can be unavailable (private mode); requests then fall back to the store's organization.
  }
};

export default setPieveSessionCompanyId;
